/** Notifications API paths, relative to `VITE_API_BASE_URL`. */
export const notificationsEndpoints = {
  list: '/notifications',
} as const;
